import { render, staticRenderFns } from "./BodyGraph.vue?vue&type=template&id=4cf3a344&scoped=true&"
import script from "./BodyGraph.vue?vue&type=script&lang=js&"
export * from "./BodyGraph.vue?vue&type=script&lang=js&"
import style0 from "./BodyGraph.vue?vue&type=style&index=0&id=4cf3a344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3a344",
  null
  
)

export default component.exports